import {LogsInitConfiguration} from "@datadog/browser-logs";
import {RumInitConfiguration} from "@datadog/browser-rum";

export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  CRITICAL = 'critical',
}

// Each log message should have a unique code.  All codes should be documented in ERRORS.md
// Note: DO NOT CHANGE EXISTING CODE VALUES - they are used in Datadog monitors / metrics
export enum LogCode {
  INTERNAL = 'Internal',
  // Fetch
  FAILED_TO_FETCH = 'FailedToFetch',
  FAILED_TO_FETCH_ACCESS = 'FailedToFetchAccess',
  FAILED_TO_FETCH_ARTICLE = 'FailedToFetchArticle',
  // Send sign-in email
  FAILED_TO_SEND_EMAIL = 'FailedToSendEmail',
  FAILED_TO_SEND_EMAIL_NETWORK_ERROR = 'FailedToSendEmailNetworkError',
  FAILED_TO_SEND_EMAIL_TOO_MANY_REQUESTS = 'FailedToSendEmailTooManyRequests',
  FAILED_TO_SEND_EMAIL_INTERNAL_SERVER_ERROR = 'FailedToSendEmailInternalServerError',
  SENT_EMAIL_LINK = 'SentEmailLink',
  // Sign in
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK = 'FailedToSignInWithEmailLink',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_PERMISSION_DENIED = 'FailedToSignInWithEmailLinkPermissionDenied',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_INVALID_LINK = 'FailedToSignInWithEmailLinkInvalidLink',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_EXPIRED_LINK = 'FailedToSignInWithEmailLinkExpiredLink',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_INVALID_OR_EXPIRED_OR_USED_LINK = 'FailedToSignInWithEmailLinkInvalidOrExpiredOrUsedLink',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_MISSING_SESSION = 'FailedToSignInWithEmailLinkMissingSession',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_NETWORK_ERROR = 'FailedToSignInWithEmailLinkNetworkError',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_TOO_MANY_REQUESTS = 'FailedToSignInWithEmailLinkTooManyRequests',
  FAILED_TO_SIGN_IN_WITH_EMAIL_LINK_INTERNAL_SERVER_ERROR = 'FailedToSignInWithEmailLinkInternalServerError',
  // Sign out
  FAILED_TO_SIGN_OUT = 'FailedToSignOut',
  FAILED_TO_SIGN_OUT_NETWORK_ERROR = 'FailedToSignOutNetworkError',
  FAILED_TO_SIGN_OUT_TOO_MANY_REQUESTS = 'FailedToSignOutTooManyRequests',
  FAILED_TO_SIGN_OUT_INTERNAL_SERVER_ERROR = 'FailedToSignOutInternalServerError',
  // Generic
  INVALID_REQUEST = 'INVALID_REQUEST',
  // View Article
  VIEW_ARTICLE_INVALID_ID = 'ViewArticleInvalidId',
  ARTICLE_NOT_FOUND = 'ArticleNotFound',
  VIEW_ARTICLE_INCORRECT_ID_SEPARATOR = 'ViewArticleIncorrectIdSeparator',
  VIEW_ARTICLE_TOO_MANY_IDS = 'ViewArticleTooManyIds',
  VIEW_ARTICLE_MISSING_ID_PARAM = 'ViewArticleMissingIdParameter',
  BRANDER_MISSING_REPLACEMENT_PARAM = 'BranderMissingReplacementParam',
  VIEW_ARTICLE_UNKNOWN_ERROR = 'ViewArticleUnknownError',
  // Access Check
  ACCESS_CHECK_MISSING_PARAMETERS = 'AccessCheckMissingParameters',
}

export interface LogContext {
  dataFields?: {
    userId?: string;
    userIds?: string[];
    articleIds?: string;
    mmoId?: string;
    branding?: string;
    [key: string]: unknown;
  };
  sessionId?: string;
  component?: string;
  pathname?: string;
  route?: string;
  correlationId?: string;
  appVersion?: string;
  logCode?: LogCode;
  redirectUrl?: string;
  boundedContext?: string;
  url?: string;
  email?: string;
  
}

export interface LogEntry {
  level: LogLevel;
  message: string;
  context?: LogContext;
  timestamp: Date;
  error?: Error;
}

export interface LoggerConfig {
  environment: string;
  minLogLevel: LogLevel;
  enableConsole: boolean;
  remoteLogging?: RemoteLoggingConfig;
  realUserMonitoring?: RealUserMonitoringConfig;
}

export interface RemoteLoggingConfig {
  enabled: boolean;
  provider: string;
  config: LogsInitConfiguration;
}

export interface RealUserMonitoringConfig {
  enabled: boolean;
  provider: string;
  config: RumInitConfiguration;
}

export interface GenericRemoteConfig {
  endpoint: string;
  apiKey?: string;
  headers?: Record<string, string>;
}
